<template>
    <div v-if="hasChips" class="cabec-popover-content">
        <div class="cabec-popover-title">Dados do cabeçalho</div>
        <div
            v-for="(c, i) in chips"
            :key="i"
            class="cabec-row"
            :class="tipoClass(c.tipo)">
            <span class="row-tag">{{ tipoIcon(c.tipo) }}</span>
            <span class="row-text">
                <span class="row-label">{{ (c.descricao || '').trim() }}:</span>
                <span class="row-value">{{ (c.resposta || '').trim() }}</span>
            </span>
        </div>
    </div>
    <div v-else class="cabec-popover-content cabec-empty">
        Sem cabeçalho preenchido.
    </div>
</template>

<script>
export default {
  name: 'CabecalhoChips',
  props: {
    cabecalhos: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    chips () {
      if (!Array.isArray(this.cabecalhos)) return []
      return this.cabecalhos.filter(c => c && c.descricao && c.resposta && c.resposta.toString().trim() !== '')
    },
    hasChips () {
      return this.chips.length > 0
    }
  },
  methods: {
    tipoIcon (tipo) {
      if (tipo === 1) return '#'
      if (tipo === 2) return '📅'
      return 'a'
    },
    tipoClass (tipo) {
      if (tipo === 1) return 'row-num'
      if (tipo === 2) return 'row-date'
      return 'row-text-type'
    }
  }
}
</script>

<style scoped>
.cabec-popover-content {
    min-width: 240px;
    font-family: 'Segoe UI';
}
.cabec-popover-title {
    font-size: 10px;
    font-weight: 700;
    color: #008144;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 2px 4px 8px 4px;
    border-bottom: 1px solid #e8eae8;
    margin-bottom: 6px;
}
.cabec-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 6px 8px;
    border: 1px solid #e8eae8;
    border-radius: 6px;
    margin-bottom: 4px;
    background: #ffffff;
}
.cabec-row:last-child {
    margin-bottom: 0;
}
.row-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    font-size: 11px;
    font-weight: bold;
    background: #d3eddc;
    color: #155724;
    padding: 0 5px;
    border-radius: 4px;
    line-height: 1;
    flex-shrink: 0;
}
.row-num .row-tag { background: #d3eddc; color: #155724; }
.row-text-type .row-tag { background: #d3eddc; color: #155724; }
.row-date .row-tag { background: #e0e0ff; color: #1a237e; font-size: 10px; }
.row-text {
    flex: 1;
    min-width: 0;
    font-size: 11px;
    line-height: 1.4;
    color: #2a3b2e;
    word-break: break-word;
}
.row-label {
    font-weight: 700;
    color: #5d7464;
    text-transform: uppercase;
    letter-spacing: 0.2px;
    margin-right: 4px;
}
.row-value {
    font-weight: 400;
    color: #1f2a22;
}
.cabec-empty {
    color: #888;
    font-style: italic;
    font-size: 11px;
    padding: 4px;
}
</style>

<style>
/* Override global (sem scoped) — afeta o popover do Bootstrap-Vue com custom-class="cabec-popover" */
.popover.cabec-popover {
    max-width: 520px;
}
.popover.cabec-popover .popover-body {
    padding: 8px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/components/cabecalhoChips/cabecalhoChips.vue